const importBusinessResourceBundle = async language => {
  switch (language) {
    case 'zh_CN':
    case 'zh-CN':
    case 'zh_cn':
    case 'zh-cn':
      return import(
        /* webpackChunkName: "business-cn-json" */ `./business/cn.json`
      );
    case 'de':
      return import(
        /* webpackChunkName: "business-de-json" */ `./business/de.json`
      );
    case 'tr':
      return import(
        /* webpackChunkName: "business-tr-json" */ `./business/tr.json`
      );
    case 'id':
      return import(
        /* webpackChunkName: "business-id-json" */ `./business/id.json`
      );
    case 'ru':
      return import(
        /* webpackChunkName: "business-ru-json" */ `./business/ru.json`
      );
    case 'th':
      return import(
        /* webpackChunkName: "business-th-json" */ `./business/th.json`
      );
    case 'es':
      return import(
        /* webpackChunkName: "business-es-json" */ `./business/es.json`
      );
    case 'fr':
      return import(
        /* webpackChunkName: "business-fr-json" */ `./business/fr.json`
      );
    case 'ja':
      return import(
        /* webpackChunkName: "business-ja-json" */ `./business/ja.json`
      );
    case 'ko':
      return import(
        /* webpackChunkName: "business-ko-json" */ `./business/ko.json`
      );
    case 'pt':
      return import(
        /* webpackChunkName: "business-pt-json" */ `./business/pt.json`
      );
    case 'zh_TW':
    case 'zh-TW':
    case 'zh_tw':
    case 'zh-tw':
      return import(
        /* webpackChunkName: "business-tw-json" */ `./business/tw.json`
      );
    case 'it':
      return import(
        /* webpackChunkName: "business-it-json" */ `./business/it.json`
      );
    case 'nl':
      return import(
        /* webpackChunkName: "business-nl-json" */ `./business/nl.json`
      );
    case 'pl':
      return import(
        /* webpackChunkName: "business-pl-json" */ `./business/pl.json`
      );
    case 'vi':
      return import(
        /* webpackChunkName: "business-vi-json" */ `./business/vi.json`
      );
    default:
      return import(
        /* webpackChunkName: "business-en-json" */ `./business/en.json`
      );
  }
};

const importConsumerResourceBundle = async language => {
  switch (language) {
    case 'zh_CN':
    case 'zh-CN':
    case 'zh_cn':
    case 'zh-cn':
      return import(
        /* webpackChunkName: "consumer-cn-json" */ `./consumer/cn.json`
      );
    case 'de':
      return import(
        /* webpackChunkName: "consumer-de-json" */ `./consumer/de.json`
      );
    case 'tr':
      return import(
        /* webpackChunkName: "consumer-tr-json" */ `./consumer/tr.json`
      );
    case 'id':
      return import(
        /* webpackChunkName: "consumer-id-json" */ `./consumer/id.json`
      );
    case 'ru':
      return import(
        /* webpackChunkName: "consumer-ru-json" */ `./consumer/ru.json`
      );
    case 'th':
      return import(
        /* webpackChunkName: "consumer-th-json" */ `./consumer/th.json`
      );
    case 'es':
      return import(
        /* webpackChunkName: "consumer-es-json" */ `./consumer/es.json`
      );
    case 'fr':
      return import(
        /* webpackChunkName: "consumer-fr-json" */ `./consumer/fr.json`
      );
    case 'ja':
      return import(
        /* webpackChunkName: "consumer-ja-json" */ `./consumer/ja.json`
      );
    case 'ko':
      return import(
        /* webpackChunkName: "consumer-ko-json" */ `./consumer/ko.json`
      );
    case 'pt':
      return import(
        /* webpackChunkName: "consumer-pt-json" */ `./consumer/pt.json`
      );
    case 'zh_TW':
    case 'zh-TW':
    case 'zh_tw':
    case 'zh-tw':
      return import(
        /* webpackChunkName: "consumer-tw-json" */ `./consumer/tw.json`
      );
    case 'it':
      return import(
        /* webpackChunkName: "consumer-tw-json" */ `./consumer/it.json`
      );
    case 'nl':
      return import(
        /* webpackChunkName: "consumer-nl-json" */ `./consumer/nl.json`
      );
    case 'pl':
      return import(
        /* webpackChunkName: "consumer-pl-json" */ `./consumer/pl.json`
      );
    case 'vi':
      return import(
        /* webpackChunkName: "consumer-vi-json" */ `./consumer/vi.json`
      );
    default:
      return import(
        /* webpackChunkName: "consumer-en-json" */ `./consumer/en.json`
      );
  }
};

const importSeoResourceBundle = async language => {
  switch (language) {
    case 'zh_CN':
    case 'zh-CN':
    case 'zh_cn':
    case 'zh-cn':
      return import(/* webpackChunkName: "seo-cn-json" */ `./seo/cn.json`);
    case 'de':
      return import(/* webpackChunkName: "seo-de-json" */ `./seo/de.json`);
    case 'tr':
      return import(/* webpackChunkName: "seo-tr-json" */ `./seo/tr.json`);
    case 'id':
      return import(/* webpackChunkName: "seo-id-json" */ `./seo/id.json`);
    case 'ru':
      return import(/* webpackChunkName: "seo-ru-json" */ `./seo/ru.json`);
    case 'th':
      return import(/* webpackChunkName: "seo-th-json" */ `./seo/th.json`);
    case 'es':
      return import(/* webpackChunkName: "seo-es-json" */ `./seo/es.json`);
    case 'fr':
      return import(/* webpackChunkName: "seo-fr-json" */ `./seo/fr.json`);
    case 'ja':
      return import(/* webpackChunkName: "seo-ja-json" */ `./seo/ja.json`);
    case 'ko':
      return import(/* webpackChunkName: "seo-ko-json" */ `./seo/ko.json`);
    case 'pt':
      return import(/* webpackChunkName: "seo-pt-json" */ `./seo/pt.json`);
    case 'zh_TW':
    case 'zh-TW':
    case 'zh_tw':
    case 'zh-tw':
      return import(/* webpackChunkName: "seo-tw-json" */ `./seo/tw.json`);
    case 'it':
      return import(/* webpackChunkName: "seo-tw-json" */ `./seo/it.json`);
    case 'nl':
      return import(/* webpackChunkName: "seo-nl-json" */ `./seo/nl.json`);
    case 'pl':
      return import(/* webpackChunkName: "seo-pl-json" */ `./seo/pl.json`);
    case 'vi':
      return import(/* webpackChunkName: "seo-vi-json" */ `./seo/vi.json`);
    default:
      return import(/* webpackChunkName: "seo-en-json" */ `./seo/en.json`);
  }
};

export default {
  type: 'backend',
  init: () => {},
  read: function(language, namespace, callback) {
    if (namespace === 'business') {
      importBusinessResourceBundle(language).then(RB => {
        callback(null, RB.default);
      });
    } else if (namespace === 'consumer') {
      importConsumerResourceBundle(language).then(RB =>
        callback(null, RB.default)
      );
    } else if (namespace === 'seo') {
      importSeoResourceBundle(language).then(RB => callback(null, RB.default));
    } else {
      callback(true, false);
    }
  },
  readMulti: () => {},
  save: () => {},
  create: () => {},
};
